(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/assets/hooks/use-orientation-detect.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/assets/hooks/use-orientation-detect.js');

'use strict';

const {
  useEffect,
  useState
} = React;
const useOrientationDetect = () => {
  const getOrientation = () => window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
  const [orientation, setOrientation] = useState(getOrientation());
  useEffect(() => {
    const handleResize = _.debounce(() => {
      setOrientation(getOrientation());
    }, 300);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return orientation;
};
Object.assign(svs.lyckoplatsen.hooks, {
  useOrientationDetect
});

 })(window);